import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'app-star-rating',
  templateUrl: './star-rating.component.html',
  styleUrls: ['./star-rating.component.css'],
  encapsulation: ViewEncapsulation.None,
  host: {
    ngSkipHydration: 'true',
  },
  standalone: false,
})
export class StarRatingComponent implements OnChanges {
  @Input() rating: number | string;
  safeRating = 0;

  ngOnChanges(changes: SimpleChanges): void {
    if ('rating' in changes) {
      const parsedRating = Number(this.rating);
      this.safeRating = Number.isFinite(parsedRating)
        ? Math.max(0, Math.min(100, parsedRating))
        : 0;
    }
  }
}
